import { render, staticRenderFns } from "./hole-group.vue?vue&type=template&id=a39b84e8"
import script from "./hole-group.vue?vue&type=script&lang=js"
export * from "./hole-group.vue?vue&type=script&lang=js"
import style0 from "./hole-group.vue?vue&type=style&index=0&id=a39b84e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports